import { render, staticRenderFns } from "./rectifyDetail.vue?vue&type=template&id=6ec772b2&scoped=true&"
import script from "./rectifyDetail.vue?vue&type=script&lang=ts&"
export * from "./rectifyDetail.vue?vue&type=script&lang=ts&"
import style0 from "./rectifyDetail.vue?vue&type=style&index=0&id=6ec772b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec772b2",
  null
  
)

export default component.exports